import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { languageSettings } from '../lenguajeDatatable';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'pdfmake';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import 'datatables.net-buttons/js/buttons.colVis';
import JSZip from 'jszip';
(window as any).JSZip = JSZip;
import 'pdfmake/build/vfs_fonts.js';
import {
  NgbDateStruct,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';
import { PersonaFiltro } from '../models/persona-filtro.model';

@Component({
  selector: 'app-titular-y-adherentes',
  templateUrl: './titular-y-adherentes.component.html',
  styleUrls: ['./titular-y-adherentes.component.css'],
})
export class TitularYAdherentesComponent implements OnInit {
  filtro: PersonaFiltro = {
    estadoActivo: null,
    esRelacionDependencia: false,
    idPlan: null,
    idTipoBeneficiario: null,
    incluirAdherentes: false,
    incluirTitulares: false,
    idObraSocial: null,
    idLocalidad: null,
    fechaDesde: null,
    fechaHasta: null,
    estado: 'activos',
    tipo: '',
    plan: '',
    obraSocial: '',
    tipoBeneficiario: '',
    idProvincia: '',
  };
  listaRelacionDependencia: any[] = [];
  listaOtros: any[] = [];
  planes: any[] = [];
  obrasSociales: any[] = [];
  tiposBeneficiario: any[] = [];
  provincias: any[] = [];
  localidades: any[] = [];
  mostrarCampoBeneficiario = false;
  dataTableRelacionDependencia: any;
  dataTableOtros: any;
  pestaniaSeleccionada: string = 'relacionDependencia';
  tablaRelacionVisible: boolean = false;
  tablaOtrosVisible: boolean = false;
  // Totalizadores para Relación de Dependencia
  totalPersonasRelacion: number = 0;
  desglosePlanRelacion: { [key: string]: number } = {};
  desgloseObraSocialRelacion: { [key: string]: number } = {};

  // Totalizadores para Otros
  totalPersonasOtros: number = 0;
  desglosePlanOtros: { [key: string]: number } = {};
  desgloseObraSocialOtros: { [key: string]: number } = {};

  // Visibilidad de secciones
  filtrosVisible: boolean = true;
  totalizadoresVisible: boolean = false;

  // Flags para saber si se realizó una búsqueda en cada pestaña
  tieneBusquedaRelacion: boolean = false;
  tieneBusquedaOtros: boolean = false;

  constructor(
    private apiSrv: ApiService,
    private loadingSrv: LoadingService,
    private ngbDateParserFormatter: NgbDateParserFormatter
  ) {}

  ngOnInit() {
    this.obtenerPlanes();
    this.obtenerTiposBeneficiarios();
    this.obtenerObrasSociales();
    this.obtenerProvincias();
  }

  ngAfterViewInit() {
    this.inicializarDataTables();
  }

  inicializarDataTables() {
    interface DataTableExtendedTypes {
      [key: string]: (data: any) => any;
    }

    if (!$.fn.dataTable.ext.type.order) {
      $.fn.dataTable.ext.type = $.fn.dataTable.ext.type || {};
      $.fn.dataTable.ext.type.order =
        $.fn.dataTable.ext.type.order || ({} as DataTableExtendedTypes);
    }

    ($.fn.dataTable.ext.type.order as DataTableExtendedTypes)['date-es-pre'] =
      function (data: string): number {
        if (!data) {
          return 0;
        }

        const parts = data.split('/');
        if (parts.length !== 3) {
          return 0;
        }

        return new Date(
          parseInt(parts[2]),
          parseInt(parts[1]) - 1,
          parseInt(parts[0])
        ).getTime();
      };

    this.dataTableRelacionDependencia = $(
      '#tablaRelacionDependencia'
    ).DataTable({
      language: languageSettings,
      pageLength: 25,
      data: this.listaRelacionDependencia,
      scrollX: false,
      responsive: true,
      dom: 'Bfrtip',
      buttons: [
        {
          extend: 'csv',
          text: 'Exportar a CSV',
          filename: 'Reporte afiliados',
          exportOptions: {
            columns: ':visible', // Solo exportar columnas visibles
          },
        },
        {
          extend: 'pdf',
          text: 'Exportar a PDF',
          orientation: 'landscape', // Orientación horizontal
          pageSize: 'A4', // Tamaño de página A4
          filename: 'Reporte afiliados',
          exportOptions: {
            columns: ':visible', // Solo exportar columnas visibles
          },
        },
        {
          extend: 'excelHtml5',
          text: 'Exportar a Excel',
          filename: 'Reporte afiliados',
          exportOptions: {
            columns: ':visible', // Solo exportar columnas visibles
          },
        },
        { extend: 'colvis', text: 'Visibilidad de columnas' },
      ],
      columns: [
        { title: 'Cuil', data: 'cuil' },
        {
          title: 'Nombre Completo',
          data: null,
          render: (data, type, row) => `${row.apellido} ${row.nombre}`,
        },
        { title: 'Documento', data: 'documento' },
        { title: 'Sexo', data: 'sexo', visible: false },
        {
          title: 'Fecha Nacimiento',
          data: 'fechaNacimiento',
          type: 'date-es',
          render: function (data, type) {
            if (type === 'display' || type === 'filter') {
              return data;
            }
            return data;
          },
        },
        {
          title: 'Fecha Venta',
          data: 'fechaVenta',
          type: 'date-es',
          render: function (data, type) {
            if (type === 'display' || type === 'filter') {
              return data || '';
            }
            return data || '';
          },
        },
        {
          title: 'Fecha Estado',
          data: 'fechaEstado',
          visible: false,
          type: 'date-es',
        },
        { title: 'Cuil Titular', data: 'cuilTitular' },
        { title: 'Parentesco', data: 'parentesco' },
        { title: 'Telefono', data: 'telefono', visible: false },
        { title: 'Localidad', data: 'localidad' },
        { title: 'Plan', data: 'plan' },
        { title: 'Obra Social', data: 'obraSocial' },
      ],
    });

    this.dataTableOtros = $('#tablaOtros').DataTable({
      language: languageSettings,
      pageLength: 25,
      data: this.listaOtros,
      scrollX: false,
      responsive: true,
      dom: 'Bfrtip',
      buttons: [
        {
          extend: 'csv',
          text: 'Exportar a CSV',
          filename: 'Reporte afiliados',
          exportOptions: {
            columns: ':visible',
          },
        },
        {
          extend: 'pdf',
          text: 'Exportar a PDF',
          filename: 'Reporte afiliados',
          orientation: 'landscape',
          pageSize: 'A4',
          exportOptions: {
            columns: ':visible',
          },
        },
        {
          extend: 'excelHtml5',
          text: 'Exportar a Excel',
          filename: 'Reporte afiliados',
          exportOptions: {
            columns: ':visible',
          },
        },
        { extend: 'colvis', text: 'Visibilidad de columnas' },
      ],
      columns: [
        { title: 'Cuil', data: 'cuil' },
        {
          title: 'Nombre Completo',
          data: null,
          render: (data, type, row) => `${row.apellido} ${row.nombre}`,
        },
        { title: 'Documento', data: 'documento' },
        { title: 'Sexo', data: 'sexo', visible: false },
        {
          title: 'Fecha Nacimiento',
          data: 'fechaNacimiento',
          type: 'date-es',
        },
        {
          title: 'Fecha Venta',
          data: 'fechaVenta',
          type: 'date-es',
        },
        {
          title: 'Fecha Estado',
          data: 'fechaEstado',
          visible: false,
          type: 'date-es',
        },
        { title: 'Cuil Titular', data: 'cuilTitular' },
        { title: 'Parentesco', data: 'parentesco' },
        { title: 'Tipo Beneficiario', data: 'tipoBeneficiario' },
        { title: 'Telefono', data: 'telefono', visible: false },
        { title: 'Localidad', data: 'localidad' },
        { title: 'Plan', data: 'plan' },
        { title: 'Obra Social', data: 'obraSocial' },
      ],
    });

    this.mostrarTabla(this.pestaniaSeleccionada);
  }

  mostrarTabla(pestania: string) {
    if (pestania === 'relacionDependencia') {
      $('#tablaRelacionDependencia').parent().show();
      $('#tablaOtros').parent().hide();
    } else {
      $('#tablaOtros').parent().show();
      $('#tablaRelacionDependencia').parent().hide();
    }
  }

  seleccionarPestania(pestania: string) {
    this.pestaniaSeleccionada = pestania;
    this.mostrarCampoBeneficiario = pestania === 'otros';

    if (pestania === 'relacionDependencia') {
      this.totalizadoresVisible = this.tieneBusquedaRelacion;
    } else {
      this.totalizadoresVisible = this.tieneBusquedaOtros;
    }
    this.mostrarTabla(this.pestaniaSeleccionada);
  }

  buscar() {
    this.loadingSrv.setLoading(true);

    const filtroObj = this.generaConsultaDinamica();

    this.apiSrv.obtenerTitularesYAdherentes(filtroObj).subscribe(
      (data) => {
        if (this.pestaniaSeleccionada === 'relacionDependencia') {
          this.listaRelacionDependencia = data;
          this.dataTableRelacionDependencia
            .clear()
            .rows.add(this.listaRelacionDependencia)
            .draw();
          this.tablaRelacionVisible = true;
          this.actualizarTotalizadoresPorPestania(
            'relacionDependencia',
            this.listaRelacionDependencia
          );
          this.tieneBusquedaRelacion = true;
          this.totalizadoresVisible = true;
        } else {
          this.listaOtros = data;
          this.dataTableOtros.clear().rows.add(this.listaOtros).draw();
          this.tablaOtrosVisible = true;
          this.actualizarTotalizadoresPorPestania('otros', this.listaOtros);
          this.tieneBusquedaOtros = true;
          this.totalizadoresVisible = true;
        }
        this.totalizadoresVisible = true;
        this.loadingSrv.setLoading(false);
      },
      (error) => {
        this.loadingSrv.setLoading(false);
      }
    );
  }

  actualizarTotalizadoresPorPestania(pestania: string, lista: any[]): void {
    if (pestania === 'relacionDependencia') {
      this.totalPersonasRelacion = lista.length;
      this.desglosePlanRelacion = {};
      this.desgloseObraSocialRelacion = {};

      lista.forEach((item) => {
        if (item.plan) {
          this.desglosePlanRelacion[item.plan] =
            (this.desglosePlanRelacion[item.plan] || 0) + 1;
        }
        if (item.obraSocial) {
          this.desgloseObraSocialRelacion[item.obraSocial] =
            (this.desgloseObraSocialRelacion[item.obraSocial] || 0) + 1;
        }
      });
    } else if (pestania === 'otros') {
      this.totalPersonasOtros = lista.length;
      this.desglosePlanOtros = {};
      this.desgloseObraSocialOtros = {};

      lista.forEach((item) => {
        if (item.plan) {
          this.desglosePlanOtros[item.plan] =
            (this.desglosePlanOtros[item.plan] || 0) + 1;
        }
        if (item.obraSocial) {
          this.desgloseObraSocialOtros[item.obraSocial] =
            (this.desgloseObraSocialOtros[item.obraSocial] || 0) + 1;
        }
      });
    }
  }

  generaConsultaDinamica(): PersonaFiltro {
    const filtroObj: PersonaFiltro = {
      cuilPersona: null,
      estadoActivo: null,
      esRelacionDependencia: false,
      idPlan: null,
      idTipoBeneficiario: null,
      incluirAdherentes: false,
      incluirTitulares: false,
      idObraSocial: null,
      idLocalidad: null,
      fechaDesde: null,
      fechaHasta: null,
    };

    if (this.filtro.tipo === 'titulares') {
      filtroObj.incluirTitulares = true;
      filtroObj.incluirAdherentes = false;
    } else if (this.filtro.tipo === 'adherentes') {
      filtroObj.incluirTitulares = false;
      filtroObj.incluirAdherentes = true;
    } else {
      filtroObj.incluirTitulares = true;
      filtroObj.incluirAdherentes = true;
    }

    filtroObj.esRelacionDependencia =
      this.pestaniaSeleccionada === 'relacionDependencia';

    if (this.filtro.estado === 'activos') {
      filtroObj.estadoActivo = 1;
    } else if (this.filtro.estado === 'inactivos') {
      filtroObj.estadoActivo = 0;
    }

    if (this.filtro.plan) {
      filtroObj.idPlan = Number(this.filtro.plan);
    }

    if (this.filtro.obraSocial) {
      filtroObj.idObraSocial = Number(this.filtro.obraSocial);
    }

    if (this.mostrarCampoBeneficiario && this.filtro.tipoBeneficiario) {
      filtroObj.idTipoBeneficiario = Number(this.filtro.tipoBeneficiario);
    }

    if (this.filtro.idLocalidad) {
      filtroObj.idLocalidad = Number(this.filtro.idLocalidad);
    }

    if (this.filtro.fechaDesdeText) {
      if (this.filtro.fechaDesdeText.includes('-')) {
        filtroObj.fechaDesde = this.filtro.fechaDesdeText;
      } else {
        const parts = this.filtro.fechaDesdeText.split('/');
        if (parts.length === 3) {
          filtroObj.fechaDesde = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
      }
    }

    if (this.filtro.fechaHastaText) {
      if (this.filtro.fechaHastaText.includes('-')) {
        filtroObj.fechaHasta = this.filtro.fechaHastaText;
      } else {
        const parts = this.filtro.fechaHastaText.split('/');
        if (parts.length === 3) {
          filtroObj.fechaHasta = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
      }
    }

    return filtroObj;
  }

  obtenerPlanes(): void {
    this.apiSrv.obtenerPlanes().subscribe(
      (data: any[]) => {
        this.planes = data;
      },
      (error) => {
        console.error('Error al obtener los planes:', error);
      }
    );
  }

  obtenerObrasSociales(): void {
    this.apiSrv.obtenerObrasSociales().subscribe(
      (data: any[]) => {
        this.obrasSociales = data;
      },
      (error) => {
        console.error('Error al obtener las obras sociales:', error);
      }
    );
  }

  obtenerTiposBeneficiarios(): void {
    this.apiSrv
      .obtenerTiposBeneficiariosExcluyendoRelacionDependencia()
      .subscribe(
        (tipos) => {
          this.tiposBeneficiario = tipos;
        },
        (error) => {
          console.error('Error al cargar tipos de beneficiarios', error);
        }
      );
  }

  toggleFiltros(): void {
    this.filtrosVisible = !this.filtrosVisible;
  }

  toggleTotalizadores(): void {
    this.totalizadoresVisible = !this.totalizadoresVisible;
  }

  obtenerProvincias(): void {
    this.apiSrv.obtenerProvincias().subscribe((data: any[]) => {
      this.provincias = data;
    });
  }

  onProvinciaChange(): void {
    this.localidades = [];
    this.filtro.idLocalidad = null;
    if (this.filtro.idProvincia) {
      this.apiSrv
        .obtenerLocalidadesSegunIdProvincia(Number(this.filtro.idProvincia))
        .subscribe(
          (data: any[]) => {
            this.localidades = data;
          },
          (error) => {
            console.error('Error al obtener las localidades:', error);
          }
        );
    }
  }

  limpiarFecha(tipo: 'fechaDesde' | 'fechaHasta'): void {
    if (tipo === 'fechaDesde') {
      this.filtro.fechaDesdeText = '';
    } else {
      this.filtro.fechaHastaText = '';
    }
  }

  private formatearFechaParaBackend(ngbDate: NgbDateStruct): string | null {
    if (!ngbDate) return null;
    const dia = ngbDate.day.toString().padStart(2, '0');
    const mes = ngbDate.month.toString().padStart(2, '0');
    const anio = ngbDate.year;
    return `${anio}-${mes}-${dia}`;
  }

  onFechaDesdeChange(fecha: NgbDateStruct) {
    this.filtro.fechaDesdeText = this.formatearFechaParaBackend(fecha);
  }

  onFechaHastaChange(fecha: NgbDateStruct) {
    this.filtro.fechaHastaText = this.formatearFechaParaBackend(fecha);
  }
}
